import { useNavigateToIndex } from "../hooks/useNavigateToIndex";

export function disallowRouteEffect(
  indexPeekWithinGroup: number | "initializing",
  indexNext: number | "initializing",
  index: number,
  navigateToIndex: ReturnType<typeof useNavigateToIndex>
) {
  if (
    indexPeekWithinGroup !== "initializing" &&
    indexNext !== "initializing" &&
    index > indexPeekWithinGroup
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    navigateToIndex(indexNext);
    return;
  } else {
    return;
  }
}
